
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elang/[word]",
      function () {
        return require("private-next-pages/elang/[word].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elang/[word]"])
      });
    }
  